export const lightPalette = {
  canvas: '#F5F2EC',
  surface: '#FFFFFF',
  elevated: '#FBF8F1',

  lineSubtle: 'rgba(15, 15, 15, 0.09)',
  lineStrong: 'rgba(15, 15, 15, 0.18)',

  textPrimary: '#171513',
  textMuted: '#5C5751',
  textFaint: '#8E867D',

  // Orange 600 — saturated, warm, pops on the cream canvas.
  accent: '#EA580C',
  accentSoft: '#F97316',
  accentDim: 'rgba(234, 88, 12, 0.10)',
  accentLine: 'rgba(234, 88, 12, 0.32)',
  accentGlow: 'rgba(234, 88, 12, 0.22)',
};

export const darkPalette = {
  canvas: '#0F0D0B',
  surface: '#15120F',
  elevated: '#1B1814',

  lineSubtle: 'rgba(255, 245, 230, 0.08)',
  lineStrong: 'rgba(255, 245, 230, 0.18)',

  textPrimary: '#EFE9DF',
  textMuted: '#A39A8C',
  textFaint: '#6B6357',

  // Orange 400 — lighter, sunlit; reads well on warm dark bg.
  accent: '#FB923C',
  accentSoft: '#F97316',
  accentDim: 'rgba(251, 146, 60, 0.10)',
  accentLine: 'rgba(251, 146, 60, 0.34)',
  accentGlow: 'rgba(251, 146, 60, 0.24)',
};

export const palette = lightPalette;
